import { ITableQueryState } from 'src/components/common/types/tableTypes';

export const buildQueryParams = (
	state: ITableQueryState,
): Record<string, string> => {
	const params: Record<string, string> = {};

	if (state.page) {
		params.page = String(state.page + 1); // mui TablePagination has 0 based index but API expects 1 based index
	}

	if (state.searchText) {
		params.search = state.searchText;
	}

	if (state.sortBy) {
		params.sort = state.sortBy;
		params.order = state.sortOrder || 'asc';
	}

	if (state.filters) {
		for (const key in state.filters) {
			const value = state.filters[key];
			if (Array.isArray(value)) {
				params[key] = value.join(',');
			} else if (value !== undefined && value !== null) {
				params[key] = String(value);
			}
		}
	}

	if (state.dateFilters) {
		if (state.dateFilters.start_date) {
			params.start_date = state.dateFilters.start_date;
		}
		if (state.dateFilters.end_date) {
			params.end_date = state.dateFilters.end_date;
		}
	}

	return params;
};
